import React, { Component, PropTypes } from 'react';
import PageModule from '../PageModule';
import css from '../css';
import EmbedModuleEditor from '../Edit/EmbedModuleEditor';
import Embed from 'cio/lib/Assets/Embed';
import IFrameEmbedder from './IFrameEmbedder';
import PageModuleActions from 'actions/PageModule';

const videoCss = oxygenCss({
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

class EmbedModule extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  componentDidMount() {
    const { editor, sources, id } = this.props;
    if (editor && sources.length < 1) {
      PageModuleActions.changePageModuleMode(id, 'edit');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.editor && !nextProps.editor) {
      PageModuleActions.changePageModuleMode(this.props.id, 'detail');
    }
  }

  render() {
    const { sources, mode, ...other } = this.props;
    const source = sources[0] || {};
    if (mode === 'edit') {
      return <EmbedModuleEditor icon={<Embed />} {...this.props} />;
    }
    return (
      <PageModule {...other}>
        <div className={videoCss.center}>
          <IFrameEmbedder provider={source.provider} data={source.data} />
        </div>
        <figcaption>{source.caption}</figcaption>
      </PageModule>
    );
  }
}

export default EmbedModule;



// WEBPACK FOOTER //
// ./src/js/module/View/EmbedModule.js